<template>
  <div
    ref="routeplanner"
    class="routeplanner"
    :style="{
      height:
        windowHeight -
        headerHeight -
        notificationsHeight -
        breadcrumbsHeight +
        'px',
      minHeight:
        windowHeight -
        headerHeight -
        notificationsHeight -
        breadcrumbsHeight +
        'px',
    }"
  >
    <div
      v-show="displaySidebar"
      class="routeplanner__desktop-sidebar"
      :style="{
        minHeight: map + 'px',
        height: map + 'px',
      }"
    >
      <div class="routeplanner__title">
        <p v-if="!isMobile" class="heading-h3 text-KQ-Grey1">
          {{ props.title }}
        </p>
        <div class="spacer"></div>
      </div>
      <div v-if="displayModal">
        <location-modal
          :airportsLoaded="allFlightsLoaded"
          @airport-selected="setDepartureAirport"
        ></location-modal>
      </div>

      <div v-show="!isMobile" class="routeplanner-booking">
        <div id="routeplanner-widget" ref="widgetNode">
          <div id="widget-front" class="widget-front">
            <div>
              <div class="widget-front__type">
                <dropdown-select
                  v-if="!isMobile"
                  v-model="dropdownTripType"
                  dropdown-title="Trip"
                  :options-array="tripOptions"
                ></dropdown-select>
                <div class="spacer"></div>
                <cabin-input v-model="passengerAndCabinClassRef"></cabin-input>
              </div>
              <div class="spacer"></div>
              <div>
                <airport-lookup
                  v-if="!isMobile"
                  v-model:airport-from="airportFrom"
                  v-model:airport-to="airportTo"
                  :allow-location="allowLocation"
                  :map-airports="availableFlights"
                  :is-planner="true"
                ></airport-lookup>
              </div>
              <div class="spacer"></div>
              <depart-return-picker
                v-if="!isMobile"
                :min-date="dayjs().subtract(1, 'day').toDate()"
                v-model:oneWay="isOneWay"
                v-model:departValue="departureDate"
                v-model:returnValue="returnDate"
              ></depart-return-picker>
              <div class="spacer"></div>
            </div>
          </div>
          <div
            id="widget-back"
            :key="widgetFlipValues.imgUrl"
            class="widget-back"
          >
            <div
              class="widget-back__container"
              :style="{
                backgroundImage: `url(${baseUrl}${widgetFlipValues.imgUrl})`,
              }"
            >
              <div
                class="
                  widget-back__container-backbtn
                  display--flex
                  items-center
                "
                :onClick="
                  () => {
                    resetFlipWidget();
                  }
                "
              >
                <i
                  class="icon icon-arrowleft icon--sm icon-color--white"
                  aria-hidden="true"
                />
              </div>
              <div>
                <div class="widget-back__container-info">
                  <div class="display--flex">
                    <p
                      class="
                        font--CabritoFlare
                        paragraph-lead
                        m-b--0
                        text-KQ-White
                      "
                    >
                      {{ widgetFlipValues.city }}
                    </p>
                    <i
                      class="icon icon-chevronright icon--xs icon-color--white"
                      aria-hidden="true"
                    />
                  </div>
                  <p class="m-b--0 text-KQ-White">
                    {{ widgetFlipValues.country }}
                  </p>
                  <div class="spacer-xsmall"></div>
                  <div class="display--flex">
                    <p class="text-KQ-White">
                      {{ widgetFlipValues.trip }} Trip
                    </p>
                    <div class="spacer-xs"></div>
                    <p class="text-KQ-Grey4">|</p>
                    <div class="spacer-xs"></div>

                    <p class="text-KQ-White">
                      {{ widgetFlipValues.passengers }}
                    </p>
                  </div>
                  <p class="paragraph-note m-b--0 text-KQ-White">
                    <span>{{ widgetFlipValues.departDate }}</span> -
                    <span>{{ widgetFlipValues.returnDate }}</span>
                  </p>
                </div>
                <div
                  class="
                    widget-back__container-footer
                    display--flex
                    items-center
                  "
                >
                  <slot name="visa-modal" :itineraries="itineraries"></slot>
                </div>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="widget-back__btn">
              <AmadeusFormSubmission refx :params="amadeusParams">
                <button role="button" type="submit" class="button">
                  Book flights
                </button>
              </AmadeusFormSubmission>
            </div>
          </div>
        </div>
      </div>
      <vue-bottom-sheet
        v-if="isMobile"
        ref="bookingWidget"
        max-height="100%"
        max-width="100%"
      >
        <div id="bookingwidget-bottomsheet">
          <div class="routeplanner__title-mobile">
            <p class="paragraph-body text--bold text-KQ-Grey1">
              Where can we fly you?
            </p>
            <button
              role="button"
              aria-label="Dismiss modal"
              class="button--text button--icon"
              :onClick="
                () => {
                  closeBookingWidgetBottomsheet();
                }
              "
            >
              <i class="icon icon-close icon--xs" aria-hidden="true"></i>
            </button>
          </div>
          <div class="spacer"></div>
          <div class="routeplanner-booking">
            <div id="routeplanner-widget-mobile" ref="widgetNodeMobile">
              <div id="widget-front" class="widget-front">
                <div>
                  <div class="widget-front__type">
                    <dropdown-select
                      v-model="dropdownTripType"
                      dropdown-title="Trip"
                      :options-array="tripOptions"
                    ></dropdown-select>
                    <div class="spacer"></div>
                    <cabin-input
                      v-model="passengerAndCabinClassRef"
                    ></cabin-input>
                  </div>
                  <div class="spacer"></div>
                  <div>
                    <airport-lookup
                      v-model:airport-from="airportFrom"
                      v-model:airport-to="airportTo"
                      :allow-location="allowLocation"
                      :map-airports="availableFlights"
                      :is-planner="true"
                    ></airport-lookup>
                  </div>
                  <div class="spacer"></div>
                  <depart-return-picker
                    v-model:oneWay="isOneWay"
                    v-model:departValue="departureDate"
                    v-model:returnValue="returnDate"
                  ></depart-return-picker>
                  <div class="spacer"></div>
                </div>
              </div>
              <div
                id="widget-back"
                :key="widgetFlipValues.imgUrl"
                class="widget-back"
              >
                <div
                  class="widget-back__container"
                  :style="{
                    backgroundImage: `url(${baseUrl}${widgetFlipValues.imgUrl})`,
                  }"
                >
                  <div
                    class="
                      widget-back__container-backbtn
                      display--flex
                      items-center
                    "
                    :onClick="
                      () => {
                        resetFlipWidget();
                      }
                    "
                  >
                    <i
                      class="icon icon-arrowleft icon--sm icon-color--white"
                      aria-hidden="true"
                    />
                  </div>
                  <div>
                    <div class="widget-back__container-info">
                      <div class="display--flex">
                        <p
                          class="
                            font--CabritoFlare
                            paragraph-lead
                            m-b--0
                            text-KQ-White
                          "
                        >
                          {{ widgetFlipValues.city }}
                        </p>
                        <i
                          class="
                            icon icon-chevronright icon--xs
                            icon-color--white
                          "
                          aria-hidden="true"
                        />
                      </div>
                      <p class="m-b--0 text-KQ-White">
                        {{ widgetFlipValues.country }}
                      </p>
                      <div class="spacer-xsmall"></div>
                      <div class="display--flex">
                        <p class="text-KQ-White">
                          {{ widgetFlipValues.trip }} Trip
                        </p>
                        <div class="spacer-xs"></div>
                        <p class="text-KQ-Grey4">|</p>
                        <div class="spacer-xs"></div>

                        <p class="text-KQ-White">
                          {{ widgetFlipValues.passengers }}
                        </p>
                      </div>
                      <p class="paragraph-note m-b--0 text-KQ-White">
                        <span>{{ widgetFlipValues.departDate }}</span> -
                        <span>{{ widgetFlipValues.returnDate }}</span>
                      </p>
                    </div>
                    <div
                      class="
                        widget-back__container-footer
                        display--flex
                        items-center
                      "
                    >
                      <slot name="visa-modal" :itineraries="itineraries"></slot>
                    </div>
                  </div>
                </div>
                <div class="spacer"></div>
                <div class="widget-back__btn">
                  <AmadeusFormSubmission refx :params="amadeusParams">
                    <button role="button" type="submit" class="button">
                      Book flights
                    </button>
                  </AmadeusFormSubmission>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-bottom-sheet>
      <div
        v-show="displayDeals"
        class="routeplanner-deals m-t--8"
        :style="
          isMobile
            ? {
                height:
                  windowHeight -
                  headerHeight -
                  notificationsHeight -
                  breadcrumbsHeight +
                  'px',
              }
            : null
        "
      >
        <recommended-list
          :deals-loading="dealsLoading"
          :deals="recommendedDeals"
          :destination="airportTo"
          :all-airports="allAirports"
        >
          <template #visamodal="visamodalprops">
            <slot name="dealsvisamodal" v-bind="visamodalprops"></slot>
          </template>
          <template #dealsmodal="dealsmodalprops">
            <slot name="dealsmodal" v-bind="dealsmodalprops"></slot>
          </template>
        </recommended-list>
      </div>
    </div>
    <div v-show="displayMap" ref="mapContainer" class="routeplanner__mapbox">
      <Map
        v-if="renderMarkers"
        :api-key="props.apiKey"
        :all-airports="allAirports"
        :locations="availableFlights"
        :selected-departure="airportFrom"
        :hover-destination="hoverDestination"
        :selected-destination="selectedDestination"
        :is-hovering="isHovering"
        @selectedDestinationName="selectedDestinationNameHandler"
      />
    </div>
    <div
      v-if="displayMobileNav && !displayFilter"
      class="routeplanner__mobilenav"
    >
      <div class="routeplanner__mobilenav--btn items-center">
        <button
          :onclick="
            () => {
              toggleMobileComponents('filters');
            }
          "
          class="display--flex items-center"
        >
          <i
            class="icon icon-filter-2 icon-color--white icon--xxs"
            aria-hidden="true"
          />
          <div class="spacer-s"></div>
          Filters
        </button>
      </div>
      <div class="routeplanner__mobilenav--divider"></div>
      <div class="routeplanner__mobilenav--btn items-center">
        <button
          v-if="displayMapBtn"
          class="display--flex items-center"
          :onclick="
            () => {
              toggleMobileComponents('map');
            }
          "
        >
          <i
            class="icon icon-filter-2 icon-color--white icon--xxs"
            aria-hidden="true"
          />
          <div class="spacer-s"></div>
          Map
        </button>
        <button
          v-if="!displayMapBtn"
          class="display--flex items-center"
          :onclick="
            () => {
              toggleMobileComponents('deals');
            }
          "
        >
          <i
            class="icon icon-list icon-color--white icon--xxs"
            aria-hidden="true"
          />
          <div class="spacer-s"></div>
          Deals
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, watchEffect, computed } from 'vue';
import Map from '../RouteMap/RouteMap.vue';
import RecommendedList from './recommended-list';
import CabinInput from '../CabinInput/CabinInput.vue';
import DropdownSelect from '../DropdownSelect/DropdownSelect.vue';
import DepartReturnPicker from '../DepartReturnPicker/DepartReturnPicker.vue';
import AirportLookup from '../AirportLookup/AirportLookup.vue';
import LocationModal from '../LocationModal/LocationModal.vue';
import optiClient from '../../services/api';
import useMatchMedia from '../../hooks/useMatchMedia';
import { formatDateShort } from '../../lib/dateUtils';
import { VueBottomSheet } from '@webzlodimir/vue-bottom-sheet';
import '@webzlodimir/vue-bottom-sheet/dist/style.css';
import { getBaseUrlContentApi } from '../../services/api/getBaseUrl';
import { useElementSize, useWindowSize } from '@vueuse/core';
import dayjs from 'dayjs';
import { useHeaderHeight } from '../../hooks/useHeaderHeight';
import useAmadeusParams from '../../hooks/useAmadeusParams';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';

let airportCodeIATA;
const { useHeaderH, useNotificationsH, useBreadcrumbsH } = useHeaderHeight();
const notificationsHeight = useNotificationsH();
const breadcrumbsHeight = useBreadcrumbsH();

const headerHeight = useHeaderH();
const mapContainer = ref(
  document.getElementsByClassName('routeplanner__mapbox')[0],
);
const isOneWay = ref(false);
const toggleWidgetDisplay = ref(true);
const widgetFrontHeight = ref('');
const widgetBackHeight = ref('');
const displayModal = ref(false);
const departureDate = ref(formatDateShort(new Date()));
const newDate = new Date();
newDate.setDate(newDate.getDate() + 7);
const returnDate = ref(formatDateShort(newDate));
const isMobile = useMatchMedia('(max-width: 991px)');
const allAirports = ref([]);
const availableFlights = ref([]);
const airportFrom = ref('');
const airportTo = ref('');
const renderMarkers = ref(false);
const allFlightsLoaded = ref(false);
const isHovering = ref(false);
const selectedDestination = ref('');
const selectedDeparture = ref('nairobi');
const hoverDestination = ref('');
const widgetNode = ref(null);
const widgetNodeMobile = ref(null);
const recommendedDeals = ref([]);

const tripOptions = [
  { label: 'Return', value: 'return' },
  { label: 'One way', value: 'oneway' },
];
const dropdownTripType = ref(tripOptions[0]);
const bookingWidget = ref(null);
const passengerAndCabinClassRef = ref({
  adults: 1,
  cabin: 'economy',
  youth: 0,
  child: 0,
  infant: 0,
});
const widgetFlipValues = ref({
  trip: 'Return',
  passengers: 0,
  city: '',
  country: '',
  departDate: '',
  returnDate: '',
  imgUrl: '',
});
const displayMobileNav = ref(false);
const displayDeals = ref(true);
const displayMap = ref(true);
const displayMapBtn = ref(false);
const displayFilter = ref(true);
const displaySidebar = ref(true);
const baseUrl = getBaseUrlContentApi();
const itineraries = ref([{}, {}]);
const dealsLoading = ref(false);
const props = defineProps({
  title: {
    type: String,
    default: 'Where can we fly you?',
  },
  apiKey: {
    type: String,
    default: '',
  },
});
const amadeusParams = useAmadeusParams({
  itinerariesRef: itineraries,
  passengerAndCabinClassRef: passengerAndCabinClassRef,
});
window.onresize = () => {
  toggleWindowSize();
};
const { height: windowHeight } = useWindowSize();
const { height: map } = useElementSize(mapContainer);
const tripDuration = computed(() => {
  const oneDay = 24 * 60 * 60 * 1000;
  const d1 = new Date(departureDate.value);
  const d2 = new Date(returnDate.value);
  return Math.round(Math.abs((d1 - d2) / oneDay)).toString();
});

const getDestinationFlights = async (iata) => {
  airportCodeIATA = iata;
  try {
    const res = await optiClient.planner.getApiV1PlannerFlightsSearch(
      iata,
      dayjs(departureDate.value).add(1,'day').format('DD MMM YY'),
      tripDuration.value,
    );
    if (Array.isArray(res)) {
      availableFlights.value = res;
      allFlightsLoaded.value = true;
      renderMarkers.value = true;
    }
  } catch (error) {
    console.log(error);
  }
};

const getDeals = async (e) => {
  try {
    dealsLoading.value = true;
    const res = await optiClient.planner.getApiV1PlannerFlightsContent(e);
    recommendedDeals.value = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    dealsLoading.value = false;
  }
};

const getAllAirports = async (e) => {
  try {
    const res = await optiClient.planner.getApiV1PlannerAirportsSearch(
      '',
      '',
      '-1',
    );
    allAirports.value = res.data[0];
  } catch (error) {
    console.log(error);
  }
};
watchEffect(() => {
  if (returnDate.value.length > 0 && departureDate.value.length > 0) {
    getDestinationFlights(airportFrom.value.locIATA);
  }
});

watch(allAirports.value, () => {
  if (
    allAirports.value.status === 200 &&
    allAirports.value.data[0].length > 0
  ) {
    renderMarkers.value = true;
  }
});

watch(
  () => isMobile.value,
  () => {
    if (isMobile.value) {
      displaySidebar.value = false;
    } else {
      displaySidebar.value = true;
    }
  },
);
watch(
  () => dropdownTripType.value,
  () => {
    if (dropdownTripType.value.value === 'oneway') {
      isOneWay.value = true;
    } else {
      isOneWay.value = false;
    }
  },
);

watch(airportFrom, (e) => {
  localStorage.setItem('selectedAirport', JSON.stringify(e));
  setDepartureAirport(airportFrom.value);
  getDeals(e.locIATA);
});

watch([() => selectedDestination.value, () => airportTo.value], () => {
  if (airportTo.value !== null) {
    if (airportTo.value.locCity === undefined) {
      if (selectedDestination.value !== airportTo.value.locCity) {
        const n = availableFlights.value.find(
          (obj) =>
            obj.locCity.trim().toLocaleLowerCase() ===
            selectedDestination.value,
        );
        airportTo.value = n;
      } else if (airportTo.value.locCity !== undefined) {
        selectedDestination.value = airportTo.value.locCity;
      }
    } else {
      selectedDestination.value = airportTo.value;
    }
  } else {
    selectedDestination.value = airportTo.value;
  }
  if (isMobile.value && airportTo.value !== null) {
    setTimeout(() => {
      openBookingWidgetBottomsheet();
    }, 500);
  }
});
watch(
  [
    () => dropdownTripType.value.value,
    () => airportFrom.value,
    () => airportTo.value,
    () => returnDate.value,
    () => departureDate.value,
    () => returnDate.value,
  ],
  () => {
    if (
      dropdownTripType.value.value === 'oneway' &&
      Object.keys(airportFrom.value).length !== 0 &&
      airportTo.value !== null &&
      Object.keys(airportTo.value).length !== 0 &&
      Date.parse(departureDate.value) > 0
    ) {
      setWidgetFlipValue(
        departureDate.value,
        returnDate.value,
        airportTo.value,
      );
      itineraries.value = [
        {
          fromAirport: airportFrom.value,
          toAirport: airportTo.value,
          departureDate: departureDate.value,
        },
        {},
      ];
      toggleWidgetDisplay.value = false;
      updateWidgetHeight();
    } else if (airportTo.value !== null) {
      if (
        dropdownTripType.value.value === 'return' &&
        Object.keys(airportFrom.value).length !== 0 &&
        (Object.keys(airportTo.value).length !== 0 || null) &&
        Date.parse(departureDate.value) > 0 &&
        Date.parse(returnDate.value) > 0
      ) {
        setWidgetFlipValue(
          departureDate.value,
          returnDate.value,
          airportTo.value,
        );
        toggleWidgetDisplay.value = false;
        itineraries.value = [
          {
            fromAirport: airportFrom.value,
            toAirport: airportTo.value,
            departureDate: departureDate.value,
          },
          {
            toAirport: airportFrom.value,
            fromAirport: airportTo.value,
            departureDate: returnDate.value,
          },
        ];
        updateWidgetHeight();
      }
    }
  },
);

const toggleWindowSize = () => {
  if (isMobile.value === false) {
    updateWidgetHeight();
    displayDeals.value = true;
  } else {
    displayMobileNav.value = true;
    displayMap.value = true;
    displayFilter.value = false;
  }
};

const toggleMobileComponents = (e) => {
  if (e === 'filters') {
    openBookingWidgetBottomsheet();
  } else if (e === 'deals') {
    displaySidebar.value = true;
    displayDeals.value = true;
    displayMap.value = false;
    displayFilter.value = false;
    displayMapBtn.value = !displayMapBtn.value;
  } else if (e === 'map') {
    displaySidebar.value = false;
    displayMap.value = true;
    displayMapBtn.value = !displayMapBtn.value;
    displayDeals.value = false;
    displayFilter.value = false;
  }
};

const flipWidget = () => {
  if (isMobile.value) {
    widgetNodeMobile.value.style.transform = 'rotateY(180deg)';
  } else {
    widgetNode.value.style.transform = 'rotateY(180deg)';
  }
};

const resetFlipWidget = () => {
  toggleWidgetDisplay.value = true;
  updateWidgetHeight();
  if (isMobile.value) {
    widgetNodeMobile.value.style.transform = 'rotateY(0deg)';
  } else {
    widgetNode.value.style.transform = 'rotateY(0deg)';
  }
  airportTo.value = null;
};

const setWidgetFlipValue = (departureDate, returnDate, destination) => {
  widgetFlipValues.value.departDate = departureDate;
  widgetFlipValues.value.returnDate = returnDate;
  widgetFlipValues.value.city = destination.locCity;
  widgetFlipValues.value.country = destination.locCountry;
  widgetFlipValues.value.trip = dropdownTripType.value.label;
  const cacheBuster = Date.now();
  setTimeout(() => {
    widgetFlipValues.value.imgUrl =
      destination.iataImageUrl + `?${cacheBuster}`;
  }, 20);
  let amountPassengers = 0;
  for (const key in passengerAndCabinClassRef.value) {
    if (
      passengerAndCabinClassRef.value[key] !== 0 &&
      typeof passengerAndCabinClassRef.value[key] === 'number'
    ) {
      amountPassengers += passengerAndCabinClassRef.value[key];
    }
  }
  const capitalizeFirstLetter = (string) =>
    `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
  if (amountPassengers > 1) {
    widgetFlipValues.value.passengers = `${amountPassengers} Passengers in ${capitalizeFirstLetter(
      passengerAndCabinClassRef.value.cabin,
    )}`;
  } else {
    widgetFlipValues.value.passengers = `1 Adult in ${capitalizeFirstLetter(
      passengerAndCabinClassRef.value.cabin,
    )}`;
  }
  flipWidget();
};

const selectedDestinationNameHandler = (e) => {
  if (e === null) {
    resetFlipWidget();
    toggleWidgetDisplay.value = !toggleWidgetDisplay.value;
  } else {
    selectedDestination.value = e;
    const n = allAirports.value.find(
      (obj) => obj.locCity.trim().toLocaleLowerCase() === e,
    );
    airportTo.value = n;
  }
};

const setDepartureAirport = (e) => {
  selectedDeparture.value = e;
  airportFrom.value = e;
  getDestinationFlights(e.locIATA);
  getDeals(e.locIATA);
  localStorage.setItem('selectedAirport', JSON.stringify(e));
};

const updateWidgetHeight = () => {
  if (document.getElementById('widget-front') !== null) {
    widgetFrontHeight.value =
      document.getElementById('widget-front').offsetHeight;
    widgetBackHeight.value =
      document.getElementById('widget-back').offsetHeight;
    if (toggleWidgetDisplay.value) {
      widgetNode.value.style.minHeight = `${widgetFrontHeight.value}px`;
    } else {
      widgetNode.value.style.minHeight = `${widgetBackHeight.value}px`;
    }
  }
};

const openBookingWidgetBottomsheet = () => {
  bookingWidget.value.open();
};

const closeBookingWidgetBottomsheet = () => {
  bookingWidget.value.close();
};

onMounted(() => {
  mapContainer.value = document.getElementsByClassName(
    'routeplanner__mapbox',
  )[0];

  const storedAirport = JSON.parse(localStorage.getItem('selectedAirport'));
  if (storedAirport !== null) {
    renderMarkers.value = true;
    displayModal.value = false;
    airportFrom.value = storedAirport;
    getDeals(storedAirport.locIATA);
  } else {
    displayModal.value = true;
  }
  getAllAirports();
  toggleWindowSize();
  updateWidgetHeight();
});
</script>
